import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/conResources',
  component: Layout,
  name: 'conResources',
  redirect: '/conResources/index',
  children: [{
    path: '/conResources/index',
    component: () => import('@/views/conResources/index'),
    name: 'conResources.index',
    meta: {
      title: i18n.t(`message.connect_resources`)
    }
  }, ]
}

export default paymentType